<template>
  <div class="content_box">
    <div class="content_box_inner">
      <el-row :gutter="10" style="margin: 10px 0">
        <el-col :xs="24" :lg="8" style="padding: 6px 0 6px 20px">
          <span>时间类型：</span>
          <el-radio-group v-model="dataTpye" @change="monthChange" size="mini">
            <el-radio label="currMonth" v-if="dataRange === 'month'"
              >当月</el-radio
            >
            <el-radio label="currQuarter" v-if="dataRange === 'quarter'"
              >当季</el-radio
            >
            <el-radio label="all">本年累计</el-radio>
          </el-radio-group>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span style="margin-left: 20px">数据指标：</span>
          <el-select
            v-model="dataIndex"
            placeholder="请选择"
            @change="monthChange"
            size="mini"
          >
            <el-option
              v-for="item in dataIndexOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :xs="24" :lg="8" style="padding: 6px 0">
          <span style="margin-left: 20px">数据类型：</span>
          <el-select
            v-model="dataRange"
            @change="dataRangeChange"
            placeholder="请选择"
            size="mini"
          >
            <el-option
              v-for="item in dataRangeOptions"
              size="mini"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col :xs="24" :lg="8" v-if="dataRange === 'month'">
          <span style="margin-left: 44px">时间：</span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            v-model="times"
            type="month"
            :height="tableData.length > 0 ? 420 : 180"
            value-format="yyyy-MM"
            @change="monthChange"
            size="mini"
            :picker-options="pickerOptions"
            placeholder="选择月"
          ></el-date-picker>
        </el-col>
        <el-col :xs="24" :lg="8" v-if="dataRange === 'quarter'">
          <span>
            <quarter
              style="margin-left: 44px"
              :default-value="defaultQuarterValue"
              v-on:getQuarter="getQuarter"
            ></quarter>
          </span>
        </el-col>
        <el-col :xs="24" :lg="8" v-if="dataRange === 'year'">
          <span style="margin-left: 44px">时间：</span>
          <el-date-picker
            class="jiance_phone_date"
            :editable="false"
            :clearable="false"
            type="year"
            v-model="times"
            value-format="yyyy"
            @change="yearChange"
            size="mini"
            :picker-options="pickerOptions"
            placeholder="选择年"
          ></el-date-picker>
        </el-col>
      </el-row>
      <el-row :gutter="10" style="margin: 10px 0px" v-if="showArea">
        <el-col align="center" style="font-size: 16px"
          >全县{{
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }}情况</el-col
        >
      </el-row>
      <el-row style="margin: 10px 0">
        <el-col :span="24">
          <Area v-if="showArea" :area-data="areaData" />
        </el-col>
      </el-row>
    </div>
    <el-link style="margin: 10px 0px" type="primary" @click="exportData">{{
      exportLabel
    }}</el-link>
    <div class="content_box_inner">
      <el-row style="margin: 10px 0px">
        <el-col :span="24">
          <el-table
            v-loading="loading"
            border
            :header-cell-style="{ backgroundColor: '#DCDFE6', color: '#000' }"
            :row-class-name="tableRowClassName"
            :data="tableData"
          >
            <el-table-column
              type="index"
              label="序号"
              width="50"
              fixed
            ></el-table-column>
            <el-table-column
              prop="area"
              width="80"
              label="地区"
              fixed
            ></el-table-column>
            <el-table-column label="趋势" width="50" fixed>
              <template slot-scope="scope">
                <el-link type="primary" @click="showDialog(scope.row)">
                  <i style="font-size: 20px" class="el-icon-data-analysis"></i>
                </el-link>
              </template>
            </el-table-column>
            <el-table-column
              :label="
                dataRange === 'month'
                  ? '当月数据'
                  : dataRange === 'quarter'
                  ? '当季数据'
                  : '当年数据'
              "
              v-if="dataRange !== 'year'"
            >
              <el-table-column
                prop="curr"
                sortable
                :formatter="handelFix2"
                label="当期（亿元）"
              ></el-table-column>
              <el-table-column
                prop="pre"
                sortable
                :formatter="handelFix2"
                label="上年同期（亿元）"
              ></el-table-column>
              <el-table-column
                prop="growthRate"
                sortable
                :formatter="handelFix1"
                label="同比增长(%)"
              ></el-table-column>
            </el-table-column>
            <el-table-column label="本年累计">
              <el-table-column
                prop="currCount"
                sortable
                :formatter="handelFix2"
                label="当期（亿元）"
              ></el-table-column>
              <el-table-column
                prop="preCount"
                sortable
                :formatter="handelFix2"
                label="上年同期（亿元）"
              ></el-table-column>
              <el-table-column
                prop="growthRateCount"
                sortable
                :formatter="handelFix1"
                label="同比增长(%)"
              ></el-table-column>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
      <el-dialog
        :title="`${areaName} - ${
          dataIndexOptions.find((ele) => ele.value === dataIndex).label
        }`"
        :visible.sync="dialogTableVisible"
        width="90%"
        @close="closeMe"
        v-if="dialogTableVisible"
      >
        <investContent
          v-on:changeDataIndex="changeDataIndex"
          :title="`${areaName}_${
            dataIndexOptions.find((ele) => ele.value === dataIndex).label
          }`"
          :data-tpye-def="dataTpye"
          :region-code-def="areaCode"
          :data-index-def="dataIndex"
          :data-range-def="dataRange"
          :times-def="times"
        ></investContent>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Area from "@/components/Echarts/area.vue";
import quarter from "@/components/dateUtils/quarter.vue";
import investContent from "./investContent";
import { export2Excel } from "@/utils/utils";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      showArea: false,
      exportLabel: "<<点击此处可导出报表",
      areaName: "",
      dialogTableVisible: false,
      loading: false,
      queryData: {},
      dataIndexOptions: [
        {
          value: "gytz",
          label: "工业投资",
        },
        {
          value: "jgtz",
          label: "技改投资",
        },
      ],
      dataRangeOptions: [
        {
          value: "month",
          label: "月度",
        },
        {
          value: "quarter",
          label: "季度",
        },
        {
          value: "year",
          label: "年度",
        },
      ],
      dataTpye: "currMonth", //时间类型
      dataIndex: "gytz", //数据指标
      dataRange: "month", //数据类型
      times: "", //时间
      defaultQuarterValue: "", //时间
      defaultMonthValue: "", //时间
      tableData: [],
      srcTableData: [],
      areaData: {
        xAxis: [],
        curr: {
          name: "",
          data: [],
        },
        pre: {
          name: "",
          data: [],
        },
        profit: {
          name: "",
          data: [],
        },
        unit: "亿元",
      },
    };
  },
  components: {
    Area,
    quarter,
    investContent,
  },
  computed: {
    ...mapGetters({
      seatList: "getAreaListArr",
    }),
  },
  watch: {
    dataRange: function (value, oldValue) {
      if (value === "quarter") {
        this.times = this.defaultQuarterValue;
      } else if (value === "month") {
        this.times = this.defaultMonthValue;
      } else {
        this.times = this.defaultMonthValue;
      }
      this.initData();
    },
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 1) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    handelFix1(row, column) {
      if (row[column.property] != null && !isNaN(row[column.property])) {
        return row[column.property].toFixed(1);
      } else {
        return row[column.property];
      }
    },
    handelFix2(row, column) {
      console.log("column.property:", column.property);
      if (row[column.property] != null && !isNaN(row[column.property])) {
        return row[column.property].toFixed(2);
      } else {
        return row[column.property];
      }
    },
    dataRangeChange(value) {
      if (value === "month") {
        this.dataTpye = "currMonth";
      } else if (value === "quarter") {
        this.dataTpye = "currQuarter";
      } else {
        this.dataTpye = "all";
      }
    },
    showDialog(row) {
      this.showArea = false;
      this.areaName = row.area;
      this.areaCode = row.code;
      console.log("this.areaCode:", this.areaCode);
      this.dialogTableVisible = true;
    },
    closeMe() {
      this.showArea = true;
      this.dialogTableVisible = false;
    },
    initData() {
      const self = this;
      this.loading = true;
      if (this.dataRange === "month") {
        this.queryData.dateType = "month";
        this.queryData.date = this.times;
      } else if (this.dataRange === "quarter") {
        this.queryData.dateType = "quarter";
        this.queryData.date = this.times;
      } else {
        this.queryData.dateType = "year";
        this.queryData.date = this.times;
      }
      this.$axios.post("/business/invest/query", this.queryData).then((res) => {
        this.tableData = [];
        this.showArea = false;
        this.loading = false;
        this.srcTableData = JSON.parse(JSON.stringify(res.data));
        if (res.data && res.data.length > 0) {
          this.areaData = {
            xAxis: [],
            curr: {
              name: "",
              data: [],
            },
            pre: {
              name: "",
              data: [],
            },
            profit: {
              name: "",
              data: [],
            },
            unit: "亿元",
          };
          res.data.forEach((item) => {
            const temp = {
              trend: "趋势",
              area: item.name,
              code: item.code,
            };
            this.areaData.xAxis.push(item.name);
            if (this.dataRange === "quarter") {
              if (this.dataIndex === "gytz") {
                // 工业增加值
                temp.curr = item.bu_this;
                temp.pre = item.bu_last;
                temp.growthRate =
                  item.bu_last > 0
                    ? ((item.bu_this - item.bu_last) / item.bu_last) * 100
                    : "--";
                temp.currCount = item.bu_this_count;
                temp.preCount = item.bu_last_count;
                temp.growthRateCount =
                  item.bu_last_count > 0
                    ? ((item.bu_this_count - item.bu_last_count) /
                        item.bu_last_count) *
                      100
                    : "--";
              } else if (this.dataIndex === "jgtz") {
                // 营业收入
                temp.curr = item.tech_this;
                temp.pre = item.tech_last;
                temp.growthRate =
                  item.tech_last > 0
                    ? ((item.tech_this - item.tech_last) / item.tech_last) * 100
                    : "--";
                temp.currCount = item.tech_this_count;
                temp.preCount = item.tech_last_count;
                temp.growthRateCount =
                  item.tech_last_count > 0
                    ? ((item.tech_this_count - item.tech_last_count) /
                        item.tech_last_count) *
                      100
                    : "--";
              }
            } else {
              if (this.dataIndex === "gytz") {
                // 工业增加值
                temp.curr = item.bu_this;
                temp.pre = item.bu_last;
                temp.growthRate = item.bu_sync;
                temp.currCount = item.bu_this_count;
                temp.preCount = item.bu_last_count;
                temp.growthRateCount =
                  item.bu_last_count > 0
                    ? ((item.bu_this_count - item.bu_last_count) /
                        item.bu_last_count) *
                      100
                    : "--";
              } else if (this.dataIndex === "jgtz") {
                // 营业收入
                temp.curr = item.tech_this;
                temp.pre = item.tech_last;
                temp.growthRate = item.tech_sync;
                temp.currCount = item.tech_this_count;
                temp.preCount = item.tech_last_count;
                temp.growthRateCount =
                  item.tech_last_count > 0
                    ? ((item.tech_this_count - item.tech_last_count) /
                        item.tech_last_count) *
                      100
                    : "--";
              }
            }
            if (this.dataTpye === "all") {
              this.areaData.curr.name = "累计";
              this.areaData.pre.name = "上年同期";
              this.areaData.profit.name = "同比增速";
              this.areaData.curr.data.push(temp.currCount);
              this.areaData.pre.data.push(temp.preCount);
              this.areaData.profit.data.push(temp.growthRateCount);
            } else {
              this.areaData.curr.name = "当期";
              this.areaData.pre.name = "上年同期";
              this.areaData.profit.name = "同比增速";
              this.areaData.curr.data.push(temp.curr);
              this.areaData.pre.data.push(temp.pre);
              this.areaData.profit.data.push(temp.growthRate);
            }
            this.tableData.push(temp);
          });
        } else {
          if (this.dataTpye === "all") {
            this.areaData = {
              xAxis: this.seatList.data.slice(1),
              curr: {
                name: "累计",
                data: [
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                ],
              },
              pre: {
                name: "上年同期",
                data: [
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                ],
              },
              profit: {
                name: "同比增速",
                data: [
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                ],
              },
              unit: "亿元",
            };
          } else {
            this.areaData = {
              xAxis: this.seatList.data.slice(1),
              curr: {
                name: "当期",
                data: [
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                ],
              },
              pre: {
                name: "上年同期",
                data: [
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                ],
              },
              profit: {
                name: "同比增速",
                data: [
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                  "--",
                ],
              },
              unit: "亿元",
            };
          }
        }
        console.log("tableData:", this.tableData);
        setTimeout(function () {
          self.showArea = true;
        }, 5);
      });
    },
    getQuarter(value) {
      this.times = value;
      this.initData();
    },
    getNowQuarter() {
      var today = new Date();
      var month = today.getMonth() + 1; //getMonth返回0-11
      var year = today.getFullYear(); //getMonth返回0-11
      if (month < 10) {
        this.defaultMonthValue = year + "-0" + month;
      } else {
        this.defaultMonthValue = year + "-" + month;
      }
      //下面是几个if
      if (month >= 1 && month <= 3)
        return year + "-" + "01" + "," + year + "-" + "03";
      else if (month >= 4 && month <= 6) {
        return year + "-" + "04" + "," + year + "-" + "06";
      } else if (month >= 7 && month <= 9) {
        return year + "-" + "07" + "," + year + "-" + "09";
      } else if (month >= 10 && month <= 12) {
        return year + "-" + "10" + "," + year + "-" + "12";
      }
    },
    monthChange(value) {
      this.initData();
    },
    yearChange(value) {
      this.times = value + "-12";
      this.times =
        this.defaultMonthValue > this.times
          ? this.times
          : this.defaultMonthValue;
      this.initData();
    },
    changeDataIndex(value) {
      if (value) {
        this.dataIndex = value;
      }
    },
    exportData() {
      let column = [];
      if (this.dataRange === "year") {
        column = [
          {
            title: "地区",
            key: "area",
            rowspan: 2,
          },
          {
            title: "本年累计",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "currCount",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "preCount",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRateCount",
              },
            ],
            colspan: 3,
          },
        ];
      } else {
        column = [
          {
            title: "地区",
            key: "area",
            rowspan: 2,
          },
          {
            title:
              this.dataRange === "quarter"
                ? "当季数据"
                : this.dataRange === "year"
                ? "当年数据"
                : "当月数据",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "curr",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "pre",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRate",
              },
            ],
            colspan: 3,
          },
          {
            title: "本年累计",
            data: [
              {
                title: "当期（亿元）",
                toFixed: 2,
                key: "currCount",
              },
              {
                title: "上年同期（亿元）",
                toFixed: 2,
                key: "preCount",
              },
              {
                title: "同比增长(%)",
                toFixed: 1,
                key: "growthRateCount",
              },
            ],
            colspan: 3,
          },
        ];
      }
      let timeStr = "";
      if (this.dataRange === "year") {
        timeStr = this.times.slice(0, 4) + "年";
      } else if (this.dataRange === "quarter") {
        let quarter = "";
        if (this.times.slice(5, 7) === "01") {
          quarter = "1";
        } else if (this.times.slice(5, 7) === "04") {
          quarter = "2";
        } else if (this.times.slice(5, 7) === "07") {
          quarter = "3";
        } else if (this.times.slice(5, 7) === "10") {
          quarter = "4";
        }
        timeStr = this.times.slice(0, 4) + "年第" + quarter + "季度";
      } else {
        timeStr = this.times.slice(0, 4) + "年" + this.times.slice(5, 7) + "月";
      }
      export2Excel(
        column,
        this.tableData,
        this.dataIndexOptions.find((ele) => ele.value === this.dataIndex)
          .label +
          "_" +
          timeStr
      );
    },
  },
  created() {
    this.defaultQuarterValue = this.getNowQuarter();
    this.times = this.defaultMonthValue;
    this.initData();
  },
};
</script>
<style lang="less" scoped>
.content_box {
  padding: 20px 30px 30px;
}

.content_box_inner {
  padding: 10px 20px 20px;
  box-shadow: 0px 0px 50px #ccc;
}

@media (max-width: 1200px) {
  .content_box {
    padding: 20px 10px 30px;
  }
  .content_box_inner {
    padding: 10px 10px 20px;
  }
}
</style>